import { useSearchDispatch } from './search-context';
import PortalAppService from '../../../application/platform/portal-app-service';
import { ISearchRequest } from '../../../model/base/request/search-request';

export function useSearchController() {
  const dispatch = useSearchDispatch();

  const performSearch = async (params: ISearchRequest) => {
    dispatch({ type: 'SEARCH_START' });

    try {
      const response = await PortalAppService.searchPortal(params);
      dispatch({ type: 'SEARCH_SUCCESS', payload: response });
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || 'Erro ao realizar busca';
      dispatch({ type: 'SEARCH_ERROR', payload: errorMessage });
    }
  };

  const resetSearch = () => {
    dispatch({ type: 'RESET_SEARCH' });
  };

  return {
    performSearch,
    resetSearch,
  };
}
